/* eslint-disable react/jsx-pascal-case */
/* eslint-disable camelcase */
import {
  AnniversaryProjectControllerService,
  anniversaryStoryVo,
  anniversarySupportVo,
} from '@/__generated__/FrontApi';
import '@/assets/font/font.css';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/scrollbar/scrollbar.min.css';
import Bg1 from '@/assets/img/involve/together_bg01.png';
import Bg1_obj from '@/assets/img/involve/together_bg01_object.png';
import Bg from '@/assets/img/involve/together_bg1.png';
import BgM from '@/assets/img/involve/together_bg1_m.jpg';
import Bg2 from '@/assets/img/involve/together_bg2.png';
import Bg3 from '@/assets/img/involve/together_bg3.png';
import Bg3_1 from '@/assets/img/involve/together_bg3_1.png';
import Bg3_1M from '@/assets/img/involve/together_bg3_1_m.png';
import Bg4 from '@/assets/img/involve/together_bg4.png';
import Bg4M from '@/assets/img/involve/together_bg4_m@2x.jpg';
import Bg5 from '@/assets/img/involve/together_bg5.png';
import Sec5img1 from '@/assets/img/involve/together_faq_arr.png';
import Sec5img2 from '@/assets/img/involve/together_faq_arr_on.png';
import TogetherImg1 from '@/assets/img/involve/together_img1@2x.png';
import TogetherImg1M from '@/assets/img/involve/together_img1_m@2x.png';
import TogetherImg2 from '@/assets/img/involve/together_img2@2x.png';
import TogetherImg2M from '@/assets/img/involve/together_img2_m@2x.png';
// import TogetherImg3 from '@/assets/img/involve/together_img3@2x.png';
import TogetherImg4 from '@/assets/img/involve/together_img4@2x.png';
import Sec2icon1 from '@/assets/img/involve/together_sec2_icon1.png';
import Sec2icon2 from '@/assets/img/involve/together_sec2_icon2.png';
import Sec2icon3 from '@/assets/img/involve/together_sec2_icon3.png';
import Sec2icon4 from '@/assets/img/involve/together_sec2_icon4.png';
import Sec2img0 from '@/assets/img/involve/together_sec2_img0.png';
import Sec2img0M from '@/assets/img/involve/together_sec2_img0_m.png';
import Sec2img1 from '@/assets/img/involve/together_sec2_img1.png';
import Event1img from '@/assets/img/involve/together_event01_img.png';
import Event2img from '@/assets/img/involve/together_event02_img.png';
import Event1icon1 from '@/assets/img/involve/together_event01_icon01.png';
import Event1icon2 from '@/assets/img/involve/together_event01_icon02.png';
import Event1icon3 from '@/assets/img/involve/together_event01_icon03.png';
import Event2icon1 from '@/assets/img/involve/together_event02_icon01.png';
import Event2icon2 from '@/assets/img/involve/together_event02_icon02.png';
import Event2icon3 from '@/assets/img/involve/together_event02_icon03.png';
import ArrwNext from '@/assets/img/involve/together_sec2_next@2x.png';
import ArrwPrev from '@/assets/img/involve/together_sec2_prev@2x.png';
import AccordionComponent, { AccordionItem } from '@/components/Accordion';
import Button from '@/components/Button';
import TogetherCard from '@/components/Card/TogetherCard';
import TogetherCard2 from '@/components/Card/TogetherCard2';
import TogetherTabSwiper from '@/components/Card/TogetherTabSwiper';
import Container from '@/components/Container';
import Image from '@/components/Image';
import AnniProjectPopup from '@/components/Layer/AnniProject/AnniProjectPopup';
import {
  AnniProjectActionType,
  isNew,
  TabProps,
} from '@/components/Layer/AnniProject/AnniProjectPopupInterface';
import PageComponent from '@/components/PageComponent';
import Section from '@/components/Section';
import SectionHeader from '@/components/SectionHeader';
import YoutubeSingle from '@/components/YoutubeSingle';
import { Tit } from '@/components/Titles';
import {
  breakpoint,
  Breakpoints,
  breakpointReverse,
} from '@/helpers/BreakpointHelper';
import { useUserStore } from '@/stores/UserStore';
import { useLocation } from '@reach/router';
import { navigate } from 'gatsby';
import { observer } from 'mobx-react-lite';
import React, {
  useState,
  useMemo,
  useEffect,
  useCallback,
  useRef,
} from 'react';
import styled from 'styled-components';
import SwiperCore, { A11y, Autoplay, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

SwiperCore.use([Navigation, Pagination, A11y, Autoplay]);

const Sec2data = [
  {
    id: 1,
    subject: `<span class="keyword">‘같이 하는 기념기부’</span> 페이지를 \n만들어주세요`,
    content: `하단 <span class="key-btn">버튼</span>을 클릭하여 후원자님의 \n‘같이 하는 기념기부’ 페이지를 만들어주세요. \n후원자님의 특별한 기념일을 선택하고 \n목표금액과 목표기간을 설정해주세요`,
    icon: Sec2icon1,
  },
  {
    id: 2,
    subject: `후원자님의 ‘같이 하는 기념기부’ \n페이지를 <span class="keyword">사람들에게 공유</span>해주세요`,
    content: `후원자님이 만드신 \n‘같이 하는 기념기부’ 페이지 링크를 \n주변 사람들에게 공유하고 \n기부에 함께 참여할 것을 요청해주세요`,
    icon: Sec2icon2,
  },
  {
    id: 3,
    subject: `<span class="keyword">따뜻한 기념일</span>을 \n완성해보세요`,
    content: `모아진 후원금은 모금 종료 후 전 세계 \n어린이를 위한 사업에 전액 지원됩니다. \n축하를 받고, 어린이에게 사랑을 전하고, \n소중한 이들에게 나눔의 장을 선물하는 \n‘같이 하는 기념기부’에 참여해 보세요.`,
    icon: Sec2icon3,
  },
];

const Sec2data2 = [
  {
    id: 1,
    subject: `<span class="keyword">‘같이 하는 기념기부’</span> 페이지를 \n만들어주세요`,
    content: `하단 <span class="key-btn">버튼</span>을 클릭하여 후원자님의 \n‘같이 하는 기념기부’ 페이지를 만들어주세요. \n후원자님의 특별한 기념일을 선택하고 \n목표금액과 목표기간을 설정해주세요`,
    icon: Sec2icon1,
  },
  {
    id: 2,
    subject: `후원자님의 ‘같이 하는 기념기부’ \n페이지를 <span class="keyword">사람들에게 공유</span>해주세요`,
    content: `후원자님이 만드신 \n‘같이 하는 기념기부’ 페이지 링크를 \n주변 사람들에게 공유하고 \n기부에 함께 참여할 것을 요청해주세요`,
    icon: Sec2icon2,
  },
  {
    id: 3,
    subject: `<span class="keyword">따뜻한 기념일</span>을 \n완성해보세요`,
    content: `모아진 후원금은 모금 종료 후 전 세계 \n어린이를 위한 사업에 전액 지원됩니다. \n축하를 받고, 어린이에게 사랑을 전하고, \n소중한 이들에게 나눔의 장을 선물하는 \n‘같이 하는 기념기부’에 참여해 보세요.`,
    icon: Sec2icon3,
  },
  {
    id: 4,
    subject: `유니세프 기념기부를 공유하고\n <span class="keyword">이벤트에 참여</span>해보세요.`,
    content: `기념일의 주인공과 함께 후원한 
    지인들 모두 SNS 공유 
    이벤트에 참여할 수 있습니다. 
    참여기간 : <strong>2023. 08. 10 ~ 이벤트 종료시까지</strong>
    이벤트 종료 후  추첨을 통해 경품을 드립니다.`,
    icon: Sec2icon4,
  },
];

const Event01Data = [
  {
    id: 1,
    content: `‘같이 하는 기념기부’ \n페이지 만들기`,
    icon: Event1icon1,
  },
  {
    id: 2,
    content: `내가 생성한 \n페이지 캡처하기`,
    icon: Event1icon2,
  },
  {
    id: 3,
    content: `필수 해시태그\n<span class="keyword">#유니세프기념기부이벤트</span> 와\n함께 본인 인스타그램 \n또는 페이스북에 공유하기`,
    icon: Event1icon3,
  },
];

const Event02Data = [
  {
    id: 1,
    content: `‘같이 하는 기념기부’\n후원에 참여하고\n메세지 남기기`,
    icon: Event2icon1,
  },
  {
    id: 2,
    content: `내가 후원한 페이지\n캡처하기 `,
    icon: Event2icon2,
  },
  {
    id: 3,
    content: `필수 해시태그
    <span class="keyword">#유니세프기념기부후원하기</span>\n<span class="keyword">#같이하는기념기부</span> 와 함께\n본인 인스타그램 \n또는 페이스북에 공유하기`,
    icon: Event2icon3,
  },
];

const faqLists = [
  {
    id: 1,
    title: `유니세프는 무엇이 다른가요?`,
    contents: `
    <span style="color: #1CABE2"><strong>1. 유니세프는 신뢰할 수 있습니다.</strong></span><br/>
    유엔 기관이기 때문입니다. 유엔아동권리협약에 직접 명시된 유일한 아동권리증진 기관이자 1965년에 노벨평화상도 수상했습니다.
    <br/><br/>
    
    <span style="color: #1CABE2"><strong>2. 유니세프는 같은 돈으로 더 많은 어린이를 구합니다.</strong></span><br/>
    유니세프는 약 80년의 경험과 전문성을 가지고 있으며 구호물품 등을 대량 구매하며 각국 정부와 협력해 근본적인 문제 해결을 추구하기 때문입니다.
    <br/><br/>
    
    <span style="color: #1CABE2"><strong>3. 유니세프는 재난 발생시 가장 먼저 현장에 접근합니다.</strong></span><br/>
    유니세프는 약 190개 나라와 영토에서 활동하며, 5개의 물류센터를 보유해 전 세계 어디서 재난이 발생해도 가장 신속하게 현장에 접근하여 어린이를 돕습니다. 긴급상황이 종료된 후에도 한결같이 어린이 곁을 지키며 지속가능한 발전을 지원합니다.
    <br/><br/>
    
    <span style="color: #1CABE2"><strong>4. 유니세프는 효율적이고 투명합니다.</strong></span><br/>
    유니세프한국위원회는 후원금 100원 중 85원을 어린이들을 위해 유니세프 본부로 송금하여, 전 세계 33개 유니세프국가위원회 중 가장 높은 수준의 송금률을 자랑합니다. 유니세프한국위원회는 국내 평가 전문 기관으로부터 높은 효율성과 투명성도 인정받고 있습니다. 
    <br/><br/>
    
    <span style="color: #1CABE2"><strong>5. 우리가 도움을 줄 차례입니다.</strong></span><br/>
    유니세프는 1950년부터 1993년까지 43년간 수많은 한국 어린이의 소중한 생명을 지켰습니다. 이제는 우리가 개발도상국 어린이들에게도 꿈꿀 기회를 주어야 합니다.

    `,
  },
  {
    id: 2,
    title: `'같이 하는 기념기부' 참여 시 기부금영수증을 받을 수 있나요?`,
    contents: `
    유니세프한국위원회 웹사이트 회원이라면 누구든 마이페이지>기부금영수증 메뉴에서 '같이 하는 기념기부'에 후원한 기부금에 대해 기부금영수증을 발급받으실 수 있습니다. <br/><br/>
    <span style="color: #666">* '같이 하는 기념기부'를 주최해주신 회원님의 경우, 모집된 전체 후원금이 아닌 실제 후원하신 내역에 대해서만 기부금영수증 발급이 가능한 점 참고하여 주시길 바랍니다.</span>
    
    `,
  },
  {
    id: 3,
    title: `기념증서를 받을 수 있나요?`,
    contents: `
    주최해주신 '같이 하는 기념기부'에 대한 기념증서 발급을 원하시는 경우, 마이페이지>1:1 문의에 글을 남겨 주시거나 아래의 연락처로 문의주시면 회원님의 메일로 감사장 발송이 가능합니다. <br/>
    전화: 02-721-5154, 메일: major@unicef.or.kr <br/>
    <br/>
    이 외, 기타 사항은 아래의 연락처로 문의를 부탁드립니다. <br/>
    -	담당팀: 특별후원팀, 전화: 02-721-5154, 이메일: major@unicef.or.kr
    
    `,
  },
];

/* ----------------------------------------- 공통 및 특수태그 생성 ----------------------------------------- */
const FrameWithObj = styled.div``;
// const Sec2block = styled.li``;
const Page = styled.div`
  .br_m {
    display: none;
    ${breakpoint(`mobile`)} {
      display: block;
    }
  }
  .br_pc {
    display: block;
    ${breakpoint(`mobile`)} {
      display: none;
    }
  }
  ${SectionHeader} {
    padding-bottom: initial;
  }
  .nxnFont {
    width: 100%;
    font-family: 'NEXON Lv1', sans-serif;
    line-height: 1;
    .c-blue {
      color: #1cabe2;
    }
  }
  .underline {
    position: relative;
    z-index: 1;
    &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 16px;
      z-index: -1;
      left: 0;
      bottom: 0;
    }
  }
  ${breakpoint(`mobile`)} {
    ${Tit} {
      font-size: 30px;
    }
    .underline {
      &:after {
        height: 13px;
      }
    }
  }
`;

/* ------------------------------------------------- 섹션1 ------------------------------------------------- */
const VideoContainer = styled.div``;
const SectionTop = styled(Section)`
  // background: #1cabe2 url(${Bg}) top center no-repeat;
  // background-size: 1920px;
  background: url(${Bg1}) 100% 100% repeat-x;
  background-size: cover;
  position: relative;
  padding-top: 80px !important;
  &::after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    ${breakpointReverse(`mobile`)} {
      background: url(${Bg1_obj}) 50% 50% no-repeat;
      // background-size: contain;
    }
  }

  ${breakpoint(`tablet`)} {
    /*
    background-position: 0 0;
    */
    &::before {
      background-size: cover;
    }
  }

  ${breakpoint(`mobile`)} {
    background: #1cabe2 url(${BgM}) bottom center no-repeat;
    background-size: cover;
    &.by-sub-main-layout:first-of-type {
      padding: 63px 0 85px;
    }
  }

  &::before {
    display: none;
  }

  ${Container} {
    position: relative;
    z-index: 10;
  }

  ${SectionHeader} {
    ${Tit} {
      line-height: 1.41;
      ${breakpoint(1160)} {
        font-size: 4.65vw;
      }
      ${breakpoint(`mobile`)} {
        font-size: 32px;
        line-height: 1.375;
        padding-top: 0;
      }
    }
    p {
      margin-top: 40px;
      font-size: 24px;
      color: #666;
      font-weight: 400;
      line-height: 1.6;
      .c-blue {
        color: #1cabe2;
      }
      ${breakpoint(`tablet`)} {
        font-size: 2.41vw;
      }
      ${breakpoint(`mobile`)} {
        font-size: 17px;
        margin-top: 10px;
        line-height: 1.4;
      }
    }
  }
  ${FrameWithObj} {
    margin: 105px 0 30px;
    max-width: 1120px;
    max-height: 568px;
    position: relative;

    ${breakpoint(`tablet`)} {
      margin: 9.05vw 0 2.59vw;
    }
    ${breakpoint(`mobile`)} {
      margin: 40px 0 0px;
    }
    picture {
      position: absolute;
      display: block;
      // *************************(1-2)방탄이미지 뒤 메모지
      &:first-of-type {
        width: 924px;
        top: -65px;
        right: -50px;
        ${breakpoint(`tablet`)} {
          width: 100%;
          top: -20px;
          right: 0;
        }
        ${breakpoint(`mobile`)} {
          max-width: 275px;
        }
      }
      // *************************(1)방탄이미지
      &:nth-of-type(2) {
        position: relative;
        box-shadow: 11px 9px 20.58px 0.42px rgba(0, 0, 0, 0.16);
        ${breakpoint(`mobile`)} {
          box-shadow: 5px 4px 10px 0.21px rgba(0, 0, 0, 0.16);
          width: calc(100% - 30px);
          margin: 0 auto;
        }
        // *************************(1-3)방탄이미지 뒤 메모지 클립
        &:after {
          content: '';
          width: 41px;
          height: 109px;
          display: block;
          position: absolute;
          background: url(${TogetherImg4}) no-repeat;
          background-size: cover;
          top: -78px;
          right: 94px;
          ${breakpoint(`mobile`)} {
            width: 3.47vw;
            height: 9.07vw;
            top: -6.4vw;
            right: 9.2vw;
          }
        }
      }
      // *************************(1-4)방탄이미지 앞 테이프
      // &:last-of-type {
      //   width: 244px;
      //   bottom: -64px;
      //   left: -73px;
      //   ${breakpoint(`tablet`)} {
      //     width: 24.62vw;
      //     bottom: -6.46vw;
      //     left: -7.37vw;
      //   }
      //   ${breakpoint(`mobile`)} {
      //     width: 20.27vw;
      //     bottom: -15px;
      //     left: -9px;
      //   }
      // }
    }
    ${breakpoint(`mobile`)} {
      ${FrameWithObj} {
        picture {
          &:first-of-type {
            max-width: 650px;
            top: -45px;
            right: -20px;
          }
          &:nth-of-type(2) {
            position: relative;
            &:after {
              width: 25px;
              height: 67px;
              top: -54px;
              right: 85px;
            }
          }
        }
      }
    }
  }
`;

/* ------------------------------------------------- 섹션2 : 어떻게 참여하나요 ------------------------------------------------- */

const Section2 = styled(Section)`
  background: #1cabe2 url(${Bg2}) no-repeat;
  background-position: 60% 25%;
  // background-size: 100% auto;
  padding: 140px 0 200px;
  ${Tit} {
    text-align: center;
    margin-bottom: 90px;
    .underline::after {
      opacity: 0.5;
      background: #b2def1;
    }
  }
  & > ${Container} {
    max-width: 1460px;
    padding: 124px 0 0;
    border-radius: 30px;
    background: #fff;
    box-shadow: 12px 10px 26.46px 0.54px rgba(0, 0, 0, 0.2);
    position: relative;

    // *************************(2-1)보드 스프링 이미지
    &:after {
      content: '';
      display: block;
      background: url(${Sec2img0}) 50% 50% no-repeat;
      width: 100%;
      height: 74px;
      position: absolute;
      top: -33px;
      left: 0;
    }

    // *************************(2)보드 디자인
    .s2_box_wrap {
      width: 100%;
      position: relative;
      padding: 0 60px 110px;
    }
  }

  .swiper-button-next,
  .swiper-button-prev {
    display: none;
  }
  .swiper-pagination {
    display: none;
  }

  // *************************(3)카드 3탭
  .s2_box {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    // width: calc(100% / 3);
    padding-top: 10px;

    // *************************(3-1)카드 3탭 상단블록
    & > ${Tit} {
      width: 100%;
      display: inherit;
      flex-direction: inherit;
      align-items: center;
      padding-bottom: 20px;
      margin-bottom: 0;
      position: relative;
      white-space: pre-wrap;
      font-family: 'NEXON Lv1', sans-serif;
      line-height: 1.5;
      // *************************(3-2)카드 3탭 넘버
      & > span {
        position: absolute;
        color: #fff;
        left: 50%;
        top: 9px;
        transform: translateX(calc(-50% - 87px));
        line-height: 1;
        &:after {
          content: '';
          display: block;
          width: 70px;
          height: 70px;
          background: #000;
          border-radius: 100%;
          position: absolute;
          top: -19px;
          left: -16px;
          z-index: -1;
        }
      }
      // *************************(3-3)카드 3탭 아이콘
      picture {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 200px;
        height: 200px;
        border-radius: 100%;
        background: #f9f9f9;
        margin-bottom: 50px;
        z-index: 1;
        img {
          width: auto;
          height: 89px;
          object-fit: scale-down;
        }
      }
      // *************************(3-4)카드 3탭 타이틀
      h2 {
        font-size: 22px;
        .keyword {
          height: 30px;
          color: #fff;
          display: inline-block;
          background: #374ea2;
          padding: 0 2px;
        }
      }
    }
    // *************************(3-5)카드 3탭 설명
    p {
      white-space: pre-wrap;
      text-align: center;
      color: #777779;
      font-size: 18px;
      font-weight: 400;
      line-height: 1.7;
      .key-btn {
        display: inline-block;
        width: auto;
        height: auto;
        background: #ffdc0e;
        border-radius: 16px;
        font-size: 18px;
        font-family: 'Noto Sans KR', sans-serif;
        font-weight: bold;
        color: #2d2926;
        padding: 0 10px;
      }
    }
  }

  .s2-event_wrap {
    padding-bottom: 110px;
  }
  .s2-event {
    position: relative;

    ${Container} {
      padding: 0;

      .event-tag {
        font-size: 23px;
        font-weight: 700;
        text-transform: uppercase;
        text-align: center;
        color: #fff;
        width: 178px;
        height: 43px;
        line-height: 43px;
        background: #1cabe2;
        border-radius: 21.5px;
        position: absolute;
        top: -21px;
        left: calc(50% - 89px);
      }

      h3 {
        font-size: 50px;
        color: #2d2926;
        padding-top: 120px;
        text-align: center;

        .underline {
          position: relative;
          z-index: 1;
          color: #1cabe2;
          &:after {
            content: '';
            width: 100%;
            height: 16px;
            opacity: 0.5;
            background: #b2def1;
            position: absolute;
            left: 0;
            bottom: 0;
            z-index: -1;
          }
        }
      }

      .event-text {
        font-size: 18px;
        color: #444;
        letter-spacing: -0.45px;
        text-align: center;
        line-height: 1.67;
        margin-top: 40px;

        span {
          color: #8b8b8b;
        }
      }

      .s2_box {
        ${Tit} {
          padding-bottom: 0;
          picture {
            background: transparent;
            margin-bottom: 30px;
            text-align: center;
            img {
              width: 200px;
              height: 200px;
            }
          }
        }
      }
    }
  }
  .s2-event01 {
    background: #e3f0f6;
    padding-bottom: 110px;

    .event01-info {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      border-radius: 0 0 73px 0;
      margin: 50px 0 76px;

      & > * {
        flex: 1;
      }

      picture {
        text-align: right;
        padding-right: 40px;
        padding-bottom: 20px;
        img {
          max-width: 467px;
          margin-top: -38px;
        }
      }

      ol {
        padding-left: 30px;
        li {
          font-size: 22px;
          font-weight: 700;
          line-height: 1.36;
          color: #2d2926;
          padding-left: 40px;
          position: relative;
          strong {
            color: #1cabe2;
            display: block;
            position: absolute;
            top: 0;
            left: 0;
          }
          & + li {
            margin-top: 20px;
          }
        }
      }
    }
  }

  .event02-info {
    display: flex;
    align-items: center;
    height: 244px;
    padding-left: 136px;
    margin: 75px 0;
    border-radius: 0 0 73px 0;
    background: #e3f0f6;

    p {
      font-size: 26px;
      font-weight: 700;
      color: #2d2926;
      padding-left: 105px;
    }

    picture {
      width: 339px;
      flex-shrink: 0;

      img {
        margin-top: -49px;
        // padding-bottom: 25px;
      }
    }
  }

  ${breakpoint(1460)} {
    ${Container} {
      width: calc(100% - 40px);
    }
  }

  ${breakpoint(1160)} {
    ${Container} {
      padding: 0;

      .s2_box_wrap {
        // margin-top: 7.76vw;
        padding: 10.34vw 5.17vw;
        &::after {
          height: 6.38vw;
          background-size: contain;
          top: -2.84vw;
        }
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      display: block;
      width: 3.012vw;
      height: 6.03vw;
    }
    .swiper-button-next::after,
    .swiper-button-prev::after {
      font-size: 0;
    }
    .swiper-button-prev {
      background: url(${ArrwPrev}) no-repeat;
      background-size: contain;
    }
    .swiper-button-next {
      background: url(${ArrwNext}) no-repeat;
      background-size: contain;
    }
    .swiper-pagination {
      position: initial;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 0 4.31vw 0;
      .swiper-pagination-bullet {
        margin: 0 0.86vw;
        font-family: 'NEXON Lv1';
        color: #fff;
        font-size: 2.41vw;
        font-weight: 700;
        &:nth-of-type(1).swiper-pagination-bullet-active {
          margin-left: 60px;
        }
        &:last-of-type.swiper-pagination-bullet-active {
          margin-right: 60px;
          margin-left: 0;
        }

        &:nth-of-type(1).swiper-pagination-bullet-active::after {
          content: '01';
        }
        &:nth-of-type(2).swiper-pagination-bullet-active::after {
          content: '02';
        }
        &:nth-of-type(3).swiper-pagination-bullet-active::after {
          content: '03';
        }
        &:nth-of-type(4).swiper-pagination-bullet-active::after {
          content: '04';
        }
      }
      .swiper-pagination-bullet-active {
        width: 4.14vw;
        height: 4.14vw;
        line-height: 4.14vw;
        background: #000;
      }
    }

    .s2_box {
      padding-top: 0;
      // *************************(3-1)카드 3탭 상단블록
      & > ${Tit} {
        // *************************(3-2)카드 3탭 넘버
        & > span {
          display: none;
        }
      }
    }
  }
  ${breakpoint(`tablet`)} {
    .swiper-button-next,
    .swiper-button-prev {
      width: 3.012vw;
      height: 6.03vw;
      margin-top: 30px;
    }
    .swiper-button-prev {
      left: 0;
    }
    .swiper-button-next {
      right: 0;
    }
    .swiper-pagination {
      margin: 0 0 4.31vw 0;
      .swiper-pagination-bullet {
        margin: 0 10px;
        font-size: 14px;
      }
      .swiper-pagination-bullet-active {
        width: 24px;
        height: 24px;
        line-height: 24px;
      }
    }
    .s2_box {
      & > ${Tit} {
        // *************************(3-3)카드 3탭 아이콘
        picture {
          width: 20.18vw;
          height: 20.18vw;
          margin-bottom: 5.05vw;
          img {
            height: 8.98vw;
          }
        }
        // *************************(3-4)카드 3탭 타이틀
        h2 {
          // font-size: 2.22vw;
          .keyword {
            // height: 3.03vw;
          }
        }
      }
      // *************************(3-5)카드 3탭 설명
      p {
        // font-size: 1.82vw;
      }
    }

    .s2-event {
      ${Container} {
        h3 {
          font-size: 4.14vw;
          padding-top: 80px;
        }
        .event-text {
          margin-top: 30px;
        }
      }
    }
    .s2-event01 {
      padding-bottom: 67px;

      .event01-info {
        flex-direction: column;
        padding: 40px 30px;
        width: calc(100% - 14px);
        margin: 35px auto 40px;
        border-radius: 0 0 36px 0;

        picture {
          padding: 0;
          img {
            margin-top: 0;
          }
        }

        ol {
          padding-left: 0;
          margin-top: 25px;
        }
      }
    }

    .event02-info {
      flex-direction: column;
      padding: 40px 30px;
      width: calc(100% - 14px);
      height: auto;
      margin: 35px auto 40px;
      border-radius: 0 0 36px 0;

      p {
        text-align: center;
        padding-left: 0;
        margin-top: 15px;
      }

      picture {
        flex-shrink: 1;

        img {
          margin-top: 0;
        }
      }
    }
  }

  ${breakpoint(`mobile`)} {
    ${Tit} {
      line-height: 1.5;
      margin-bottom: 50px;
    }
    ${Container} {
      padding: 0;
      .s2_box_wrap {
        padding: 40px 15px 82px;
        border-radius: 15px;
        &::after {
          height: 30px;
          background: url(${Sec2img0M}) no-repeat 50% 50%;
          background-size: contain;
        }
      }
    }
    .swiper-button-next,
    .swiper-button-prev {
      width: 18px;
      height: 36px;
    }
    .swiper-pagination {
      .swiper-pagination-bullet {
        margin: 0 5px;
        width: 5px;
        height: 5px;
        &:nth-of-type(1).swiper-pagination-bullet-active {
          margin-left: 30px;
        }
        &:last-of-type.swiper-pagination-bullet-active {
          margin-right: 30px;
        }
      }
      .swiper-pagination-bullet-active {
        width: 24px;
        height: 24px;
        line-height: 24px;
      }
    }
    .s2_box {
      & > ${Tit} {
        padding-bottom: 15px;
        picture {
          width: 108px;
          height: 108px;
          margin-bottom: 30px;
          img {
            height: 46px;
          }
        }
        h2 {
          font-size: 16px;
          line-height: 1.38;
          .keyword {
            height: 19px;
          }
        }
      }
      p {
        font-size: 14px;
        line-height: 1.43;
        .key-btn {
          font-size: 14px;
          padding: 0 5px;
        }
      }
    }

    .s2-event_wrap {
      padding-bottom: 70px;
    }
    .s2-event {
      ${Container} {
        .event-tag {
          font-size: 16px;
          width: 98px;
          height: 24px;
          border-radius: 12px;
          line-height: 24px;
          top: -12px;
          left: calc(50% - 49px);
        }

        h3 {
          font-size: 23px;
          line-height: 1.43;
          padding-top: 45px;
          .underline {
            &::after {
              height: 13px;
            }
          }
        }

        .event-text {
          font-size: 14px;
          line-height: 1.43;
          letter-spacing: -0.475px;
          margin-top: 15px;
          span {
            font-size: 12px;
          }
        }

        .s2_box {
          & > ${Tit} {
            picture {
              width: 108px;
              height: 108px;
              img {
                width: 108px;
                height: 108px;
              }
            }
          }
        }
      }
    }

    .s2-event01 {
      .event01-info {
        picture {
          img {
            max-width: 211px;
          }
        }

        ol {
          li {
            font-size: 11px;
            line-height: 1.36;
            padding-left: 20px;

            & + li {
              margin-top: 10px;
            }
          }
        }
      }
    }

    .event02-info {
      p {
        font-size: 11px;
      }

      picture {
        width: 100%;
        max-width: 171px;
      }
    }
  }
`;

const ButtonContainer = styled.div`
  display: block;
  height: 100%;
  text-align: center;

  // *************************(3-6)카드 3탭 버튼
  width: 380px;
  height: 90px;
  margin: 60px auto 0;
  position: relative;
  & > * {
    width: 100%;
  }
  &:after {
    content: '';
    display: block;
    position: absolute;
    background: url(${Sec2img1}) no-repeat;
    background-size: cover;
    width: 87px;
    height: 50px;
    top: -20px;
    right: -17px;
  }
  button {
    height: 100%;
    font-family: 'NEXON Lv1', sans-serif;
    font-size: 24px;
    border-radius: 45px;
  }
  ${breakpoint(`tablet`)} {
    width: 72.26vw;
    max-width: 400px;
    height: 60px;
    margin: 6.05vw auto 0;
    &:after {
      width: 70px;
      background-size: 70px auto;
    }
    button {
      // font-size: 2.43vw;
    }
  }

  ${breakpoint(`mobile`)} {
    padding-left: 0;
    margin: 35px auto 0;
    width: calc(100% - 34px);
    max-width: 271px;
    height: 40px;
    line-height: 38px;
    text-align: center;
    &:after {
      width: 54px;
      height: 31px;
      background-size: contain;
      top: -17px;
      right: 7px;
    }
    button {
      max-width: 100%;
      font-size: 16px;
      border-radius: 20px;
    }
  }
`;

/* ------------------------------------------------- 섹션3 : 함께하는 기념기부 이야기 ------------------------------------------------- */
const Section3 = styled(Section)`
  background: rgba(0, 0, 0, 1) url(${Bg3}) bottom center no-repeat;
  background-size: cover;
  ${Container} {
    max-width: 100%;
    ${SectionHeader} {
      padding: 20px 20px 0;
      max-width: 1160px;
      display: block;
      margin: 0 auto;
      ${Tit} {
        .underline::after {
          opacity: 0.3;
          background: #1cabe2;
        }
      }
      ${breakpoint(`mobile`)} {
        text-align: center;
        .br_m { display: none; }
      }
      ${breakpoint(360)} {
        .br_m { display: block; }
      }
    }
    ${breakpoint(`tablet`)} {
        padding: 0;
      }
    }

    .swiper-slide {
      width: 600px;
      box-shadow: 12px 10px 26.46px 0.54px rgba(0, 0, 0, 0.17);
      &:first-child {
        margin-left: calc((100% - 1120px) / 2);
      }
      &:last-child {
        margin-right: calc((100% - 1120px) / 2);
      }
      ${breakpoint(1160)} {
        &:first-child {
          margin-left: 0;
        }
        &:last-child {
          margin-right: 0;
        }
      }
      ${breakpoint(`mobile`)} {
        width: 80vw;
        & + .swiper-slide {
          margin-left: 20px;
        }
      }
    }
    .swiper-scrollbar {
      ${breakpoint(`tablet`)} {
        width: calc(100% - 40px);
        left: 20px;
      }
    }
  }
  ${breakpoint(1160)} {
    .swiper-slide:first-child {
      margin-left: 0;
    }
    .swiper-slide:last-child {
      margin-right: 0;
    }
  }
  ${breakpoint(`mobile`)} {
    padding: 60px 0;
    .swiper-container {
      padding: 44px 20px 40px;
    }
    .swiper-slide {
      width: 80vw;
      & + .swiper-slide {
        margin-left: 20px;
      }
    }
  }
`;

/* ------------------------------------------------- 섹션3-1 : 후원과 참여 ------------------------------------------------- */
const Section3_1 = styled(Section)`
  background: #fff url(${Bg3_1}) top center no-repeat;
  background-size: 100% auto;
  ${Container} {
    max-width: 1154px;
    padding: 0 34px 0 0;
    overflow: hidden;
    ${SectionHeader} {
      padding: 140px 0 0 0;
      max-width: 1160px;
      display: block;
      margin: 0 auto;
      ${Tit} {
        .underline::after {
          opacity: 0.3;
          background: #1cabe2;
        }
      }
    }
  }
  ${breakpoint(1160)} {
    ${Container} {
      padding: 0 20px;
      ${SectionHeader} {
        padding: 14.13vw 0 0 0;
      }
    }
  }
  ${breakpoint(`tablet`)} {
    ${Container} {
      padding-bottom: 50px;
    }
  }
  ${breakpoint(`mobile`)} {
    background: #fff url(${Bg3_1M}) top center no-repeat;
    background-size: 100% auto;
    ${Container} {
      padding: 70px 20px;
      ${SectionHeader} {
        padding: 0;
        ${Tit} {
          text-align: center;
        }
      }
    }
  }
`;

/* ------------------------------------------------- 섹션4 : 페이지 찾기 ------------------------------------------------- */
const Section4 = styled(Section)`
  overflow: hidden;
  background: rgba(0, 0, 0, 1) url(${Bg4}) top center no-repeat;
  background-size: cover;
  position: relative;
  min-height: 1300px;
  &.by-sub-main-layout {
    padding: 0;
    text-align: center;
  }
  .source {
    font-family: 'NEXON Lv1', sans-serif;
    font-size: 16px;
    color: #fff;
    letter-spacing: -0.32px;
    position: absolute;
    right: 57px;
    bottom: 30px;

    & > .source_m {
      display: none;
    }
  }

  ${Container} {
    padding: 0 20px;
    margin: 140px 0;
    display: inline-block;
    ${SectionHeader} {
      padding-bottom: 120px;
      ${Tit} {
        color: #fff;
        .underline::after {
          opacity: 0.3;
          background: #fff;
        }
      }
      p {
        font-size: 18px;
        font-weight: 300;
        line-height: 1.8;
        color: #fff;
        opacity: 0.8;
        padding-top: 40px;
      }
    }
    ${breakpoint(`mobile`)} {
      margin: 70px 0;
    }
  }
  ${breakpoint(`mobile`)} {
    background: rgba(0, 0, 0, 1) url(${Bg4M}) top center no-repeat;
    background-size: cover;
    min-height: 120vh;

    .source {
      font-size: 13px;
      right: 26px;
      bottom: 20px;

      & > .source_pc {
        display: none;
      }
      & > .source_m {
        display: inline-block;
      }
    }

    ${Container} {
      ${SectionHeader} {
        p {
          font-size: 14px;
          line-height: 1.43;
          padding-top: 15px;
        }
      }
    }
  }
`;

/* ------------------------------------------------- 섹션5 : FAQ ------------------------------------------------- */
const Section5 = styled(Section)`
  background: rgba(0, 0, 0, 1) url(${Bg5}) bottom center no-repeat;
  background-size: cover;
  h2 {
    text-align: center;
    margin-bottom: 60px;
    ${Tit} {
      font-family: 'NanumBarunGothic';
    }
  }
  ul {
    border: none;
    li {
      border: 0;
      header {
        border: 0;
        position: relative;
        &::before {
          content: 'Q';
          display: flex;
          align-items: center;
          justify-content: center;
          width: 61px;
          height: 61px;
          border-radius: 100%;
          background: #000;
          font-family: 'NEXON Lv1';
          font-size: 30px;
          color: #fff;
          font-weight: 700;
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
        }
        &::after {
          right: 40px;
          /*
          z-index: 10;
          */
        }
        .accordion-opener {
          border: 2px solid #d8d1c9;
          border-radius: 20px;
          background: transparent;
          margin-left: 58px;
          margin-top: 30px;
          padding: 30px 40px;
          position: relative;

          &:before {
            content: '';
            display: inline-block;
            width: 16px;
            height: 17px;
            background: url(${Sec5img1}) no-repeat;
            position: absolute;
            top: 50%;
            left: -15px;
            transform: translateY(-50%);
          }
        }
      }
      .accordion-content {
        position: relative;
        &::before {
          content: 'A';
          display: flex;
          align-items: center;
          justify-content: center;
          width: 61px;
          height: 61px;
          border-radius: 100%;
          border: 2px solid #000;
          background: #1cabe2;
          font-family: 'NEXON Lv1';
          font-size: 30px;
          color: #000;
          font-weight: 700;
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
        }
        > div {
          padding: 30px 40px;
          border: 2px solid #000;
          border-radius: 20px;
          margin-left: 58px;
          margin-top: 10px;
          position: relative;
          &::before {
            content: '';
            display: inline-block;
            width: 16px;
            height: 17px;
            background: url(${Sec5img2}) no-repeat 50% 50%;
            position: absolute;
            top: 50%;
            left: -15px;
            transform: translateY(-50%);
          }
        }
      }

      &.is-active {
        border: 0;
        header {
          border: 0;
          .accordion-opener {
            border-color: #000;
            &:before {
              background: url(${Sec5img2}) no-repeat 50% 50%;
            }
          }
        }
      }
    }
  }
  ${breakpoint(`tablet`)} {
    ul li {
      .accordion-opener {
        padding-left: 40px !important;
        font-size: 2.01vw;
      }
      .accordion-content > div {
        font-size: 1.61vw;
      }
    }
  }
  ${breakpoint(`mobile`)} {
    &.by-sub-main-layout {
      padding: 60px 0 75px;
    }
    h2 {
      margin-bottom: 40px;
    }
    ul li {
      header {
        &::before {
          width: 35px;
          height: 35px;
          font-size: 20px;
        }
        &::after {
          width: 20px;
          height: 20px;
          background-size: 20px;
          right: 20px;
        }
        .accordion-opener {
          margin-left: 35px;
          margin-top: 20px;
          padding: 17px 20px !important;
          border-radius: 10px;
          font-size: 15px;
          &::before {
            width: 10px;
            height: 10px;
            background-size: contain;
            left: -9px;
          }
          &:not(.plain-item) {
            padding-right: 40px !important;
          }
        }
      }
      .accordion-content {
        &::before {
          width: 35px;
          height: 35px;
          font-size: 20px;
        }
        > div {
          margin-left: 35px;
          border-radius: 10px;
          padding: 20px;
          font-size: 13px;
          &::before {
            width: 10px;
            height: 10px;
            background-size: contain;
            left: -9px;
          }
        }
      }
      &.is-active {
        header {
          ::after {
            background-size: 20px;
          }
          .accordion-opener {
            &:before {
            }
          }
        }
      }
    }
  }
`;
const NavigationButton = styled.div`
  padding: 24px 48px 24px 24px;
  cursor: pointer;
  font-weight: bold;
  font-size: 20px;
  position: relative;
  ${breakpoint(`mobile`)} {
    font-size: 16px;
    padding: 20px 40px 20px 0;
  }
`;
const AccordionBody = styled.div`
  padding: 24px;
  font-size: 16px;
  color: #2d2926;
  ${breakpoint(`mobile`)} {
    font-size: 14px;
    padding: 16px 0;
  }
  // blut css 보정
  ul,
  ol,
  li {
    list-style: inherit;
    list-style-position: inside;
    list-style-type: inherit;
  }
  ol {
    list-style-type: demical;
  }
  ul {
    list-style-type: disc;
  }
  a {
    color: #1cabe2;
  }
`;

const SectionSpecialDay = styled(Section)`
  background: #f8f9fa;
  padding: 40px 0;

  ${SectionHeader} {
    padding-bottom: 24px;
  }
  article {
    margin-bottom: 40px;

    &:last-child {
      margin-bottom: 0;
    }
    .dec,
    .blit-list {
      line-height: 1.7;
    }
    .tit {
      display: block;
      margin-bottom: 4px;
    }
    .dec {
      margin-top: 40px;
    }
  }

  ${breakpoint(`tablet`)} {
    padding: 24px 0;

    ${SectionHeader} {
      padding-bottom: 16px;
      .header-dec {
        margin-top: 24px;
      }
    }
    article {
      margin-bottom: 32px;

      .dec {
        margin-top: 32px;
      }
    }
  }
`;

const TogetherTab: React.FC<TabProps> = observer(
  ({ toScroll, resetScroll, ...props }) => {
    const { search } = useLocation();
    const queryParams = useMemo(() => new URLSearchParams(search), [search]);
    const [storyItems, setStoryItems] = useState<any[]>([]);
    const [supportItems, setSupportItems] = useState<any[]>([]);
    const userStore = useUserStore();
    const screenWidth = typeof window !== 'undefined' ? window.screen.width : 0;

    // 함께하는 기념기부 데이터 로딩
    const loadStory = useCallback(async () => {
      AnniversaryProjectControllerService.selectAnniversaryStoryListUsingGet({})
        .then(({ data, resultCode }) => {
          setStoryItems([]);
          if (resultCode === `success`) {
            const item = data as anniversaryStoryVo[];
            setStoryItems(item);
          }
        })
        .catch(() => {
          setStoryItems([]);
        });
    }, []);
    useEffect(() => {
      loadStory();
    }, [loadStory]);

    // 후원과 참여 데이터 로딩
    const loadSupport = useCallback(async () => {
      AnniversaryProjectControllerService.selectAnniversarySupportListUsingGet(
        {},
      )
        .then(({ data, resultCode }) => {
          setSupportItems([]);
          if (resultCode === `success`) {
            const item = data as anniversarySupportVo[];
            setSupportItems(item);
          }
        })
        .catch(() => {
          setSupportItems([]);
        });
    }, []);
    useEffect(() => {
      loadSupport();
    }, [loadSupport]);

    //영문 버튼 이동
    const Eng = useRef();
    useEffect(() => {
      // console.log('useEffect: ', toScroll);
      if (toScroll !== 0) {
        Eng.current.scrollIntoView({ behavior: `smooth` });
        if (resetScroll) resetScroll();
      } else {
      }
    }, [toScroll]);
    // console.log('load: ', toScroll);

    // 기념기부 프로젝트 팝업 (dynamic)
    const [anniPrjtPopupState, setAnniPrjtPopupState] = useState(false);
    const [anniPrjtPopupAction, setAnniPrjtPopupAction] = useState(
      AnniProjectActionType.write,
    );
    const [anniPrjtPopupId, setAnniPrjtPopupId] = useState(0);
    const anniPrjtPopupOpen = (
      popAction: AnniProjectActionType,
      popId?: number,
    ) => {
      setAnniPrjtPopupAction(popAction);
      setAnniPrjtPopupId(popId || 0);
      setAnniPrjtPopupState(true);
    };

    // 외부 공유 url로 팝업 오픈
    const [anniProjectId, setAnniProjectId] = useState(0);
    useEffect(() => {
      const aid: number = Number(queryParams.get('aid')) || 0;
      const action: AnniProjectActionType =
        queryParams.get('admin') === 'Y'
          ? AnniProjectActionType.admin
          : AnniProjectActionType.detail;
      setAnniProjectId(aid);
      if (aid > 0) {
        anniPrjtPopupOpen(action, aid);
      }
    }, [queryParams]);

    const anniPrjtPopupClose = () => {
      setAnniPrjtPopupState(false);
      setAnniPrjtPopupId(0);
      // sns 유입 queryString 초기화
      if (anniProjectId) {
        setAnniProjectId(0);
        navigate(`.`);
      }
    };

    const FindPage = useRef();
    const scrollToFindPage = () => {
      FindPage.current.scrollIntoView({ behavior: `smooth` });
    };

    return (
      <Page>
        <SectionTop className="by-sub-main-layout">
          <Container>
            <SectionHeader className="with-desc">
              <h2>
                <Tit size="s1" className="nxnFont">
                  <span className="c-blue">
                    여러분의
                    <br className="br_m" /> 특별한 기념일!
                  </span>{' '}
                  <br />
                  많은 이들과
                  <br className="br_m" /> 나눔을 공유하는 <br />
                  기쁜 날로
                  <br className="br_m" /> 만들 수 있습니다.
                </Tit>
              </h2>
              <p>
                &lsquo;같이 하는 기념기부&rsquo; 란?
                <br /> 나를 위한 기념일 선물 대신 지인들의 기부를 통해 전 세계
                어린이를 지원할 수 있습니다.
                <br /> 생일, 졸업, 결혼, 합격… <br className="br_m" />
                누구나 인생에서 맞이하는 의미 있는
                <br className="br_m" />
                기념일이 있습니다. <br />이 특별한 날!{' '}
                <span className="c-blue">
                  소중한 가족과 친구들이 나와 함께 기부에 참여하면
                </span>
                &nbsp; 여러분의 기념일이 세상에서 가장 <br className="br_pc" />
                따뜻하고 빛나는 하루가 될 것입니다.
              </p>
            </SectionHeader>
            <FrameWithObj>
              <Image pcSrc={TogetherImg2} mobileSrc={TogetherImg2M} />
              <picture>
                <PageComponent id="mainYoutube" addClass="together">
                  <PageComponent
                    id={
                      Breakpoints.mobile < screenWidth
                        ? 'mainImgPc'
                        : 'mainImgMob'
                    }
                  >
                    <source
                      srcSet={`${TogetherImg1M} 2x`}
                      media={`(max-width: ${Breakpoints.mobile}px)`}
                      type="image/png"
                    />
                    <source srcSet={`${TogetherImg1} 2x`} />
                    <img
                      src={TogetherImg1}
                      alt=""
                      css={`
                        width: 100%;
                      `}
                    />
                  </PageComponent>
                </PageComponent>
              </picture>
              {/* <Image pcSrc={TogetherImg3} mobileSrc={TogetherImg3} /> */}
            </FrameWithObj>
          </Container>
        </SectionTop>
        <Section2 className="by-sub-main-layout">
          <SectionHeader>
            <h2>
              <Tit size="s1" color="white" className="nxnFont">
                <span className="underline">같이 하는 기념기부,</span>&nbsp;
                <br className="br_m" />
                어떻게 참여하나요?
              </Tit>
            </h2>
          </SectionHeader>
          <Container>
            <div className="s2_box_wrap">
              {isNew ? (
                <Swiper
                  slidesPerView={1}
                  slidesPerGroup={1}
                  navigation
                  pagination={{ clickable: true }}
                  breakpoints={{
                    1160: {
                      slidesPerView: 4,
                      slidesPerGroup: 4,
                      touchRatio: 0,
                    },
                  }}
                >
                  {Sec2data2.map((row) => (
                    <SwiperSlide className="s2_box" key={row.id}>
                      <Tit size="s4-1" weight="black">
                        <span>0{row.id}</span>
                        <Image pcSrc={row.icon} mobileSrc={row.icon} />
                        <h2 dangerouslySetInnerHTML={{ __html: row.subject }} />
                      </Tit>
                      <p dangerouslySetInnerHTML={{ __html: row.content }}></p>
                    </SwiperSlide>
                  ))}
                </Swiper>
              ) : (
                <Swiper
                  slidesPerView={1}
                  slidesPerGroup={1}
                  navigation
                  pagination={{ clickable: true }}
                  breakpoints={{
                    1160: {
                      slidesPerView: 3,
                      slidesPerGroup: 3,
                      touchRatio: 0,
                    },
                  }}
                >
                  {Sec2data.map((row) => (
                    <SwiperSlide className="s2_box" key={row.id}>
                      <Tit size="s4-1" weight="black">
                        <span>0{row.id}</span>
                        <Image pcSrc={row.icon} mobileSrc={row.icon} />
                        <h2 dangerouslySetInnerHTML={{ __html: row.subject }} />
                      </Tit>
                      <p dangerouslySetInnerHTML={{ __html: row.content }}></p>
                    </SwiperSlide>
                  ))}
                </Swiper>
              )}

              <ButtonContainer>
                {!userStore.isLoggedIn() ? (
                  <Button
                    color="yellow"
                    // width={380}
                    onClick={() =>
                      navigate(
                        `/auth/login/?redirectTo=/involve/individual/together/`,
                      )
                    }
                  >
                    <span>같이 하는 기념기부 만들기</span>
                  </Button>
                ) : (
                  <Button
                    color="yellow"
                    // width={350}
                    onClick={() => {
                      anniPrjtPopupOpen(AnniProjectActionType.write);
                      /*
                    // 완료
                    anniPrjtPopupOpen(AnniProjectActionType.complete, id_num);
                    // 관리
                    anniPrjtPopupOpen(AnniProjectActionType.admin, id_num);
                    // 상세
                    anniPrjtPopupOpen(AnniProjectActionType.detail, id_num);
                    */
                    }}
                  >
                    <span>같이 하는 기념기부 만들기</span>
                  </Button>
                )}
              </ButtonContainer>
            </div>

            {isNew ? (
              <>
                <div className="s2-event_wrap">
                  <div className="s2-event s2-event01">
                    <Container>
                      <div className="event-tag nxnFont">event 01</div>

                      <h3 className="nxnFont">
                        ‘기념일의 주인공’을 위한
                        <br className="br_m" />{' '}
                        <span className="underline">인증 이벤트</span>
                      </h3>
                      <p className="event-text">
                        유니세프 ‘같이 하는 기념기부’ 페이지를 만들고 생성된
                        페이지를 SNS에 올려주세요.
                        <br />
                        주변 지인과 기념일을 함께 축하 할 수 있도록 다양한
                        경품을 드립니다.
                        <br />
                        <span>
                          (나의 ‘같이 하는 기념기부‘ 페이지에 지인이 후원을 한
                          경우 이벤트에 참여할 수 있습니다.)
                        </span>
                      </p>
                      <div className="event01-info">
                        <Image pcSrc={Event1img} mobileSrc={Event1img} />
                        <ol>
                          <li className="nxnFont">
                            <strong>1등</strong> (5명) 패밀리 레스토랑 상품권
                            (50,000원)
                            <br /> + 유니세프 우드클락
                          </li>
                          <li className="nxnFont">
                            <strong>2등</strong> (15명) 영화관람권 (30,000원)
                          </li>
                          <li className="nxnFont">
                            <strong>3등</strong> (80명) 아이스 카페라떼
                            모바일상품권
                          </li>
                        </ol>
                      </div>
                      <Swiper
                        slidesPerView={1}
                        slidesPerGroup={1}
                        navigation
                        pagination={{ clickable: true }}
                        breakpoints={{
                          1160: {
                            slidesPerView: 3,
                            slidesPerGroup: 3,
                            touchRatio: 0,
                          },
                        }}
                      >
                        {Event01Data.map((row) => (
                          <SwiperSlide
                            className="event01-swiper s2_box"
                            key={row.id}
                          >
                            <Tit size="s4-1" weight="black">
                              <span>0{row.id}</span>
                              <Image pcSrc={row.icon} mobileSrc={row.icon} />
                              <h2
                                dangerouslySetInnerHTML={{
                                  __html: row.content,
                                }}
                              />
                            </Tit>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </Container>
                  </div>

                  <div className="s2-event s2-event02">
                    <Container>
                      <div className="event-tag nxnFont">event 02</div>

                      <h3 className="nxnFont">
                        ‘같이 하는 기념기부 참여자’를 위한{' '}
                        <span className="underline">후원 이벤트</span>
                      </h3>
                      <p className="event-text">
                        ‘같이 하는 기념기부’에 후원하고 SNS에 공유해주시면{' '}
                        <br className="br_pc" />
                        추첨을 통해 특별한 유니세프 카드 USB를 드립니다.
                      </p>
                      <div className="event02-info">
                        <Image pcSrc={Event2img} mobileSrc={Event2img} />
                        <p className="nxnFont">
                          유니세프 카드형 USB 32GB (100명)
                        </p>
                      </div>
                      <Swiper
                        slidesPerView={1}
                        slidesPerGroup={1}
                        navigation
                        pagination={{ clickable: true }}
                        breakpoints={{
                          1160: {
                            slidesPerView: 3,
                            slidesPerGroup: 3,
                            touchRatio: 0,
                          },
                        }}
                      >
                        {Event02Data.map((row) => (
                          <SwiperSlide
                            className="event02-swiper s2_box"
                            key={row.id}
                          >
                            <Tit size="s4-1" weight="black">
                              <span>0{row.id}</span>
                              <Image pcSrc={row.icon} mobileSrc={row.icon} />
                              <h2
                                dangerouslySetInnerHTML={{
                                  __html: row.content,
                                }}
                              />
                            </Tit>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </Container>
                  </div>

                  <ButtonContainer>
                    <Button
                      color="yellow"
                      // width={390}
                      full
                      onClick={scrollToFindPage}
                    >
                      <span>친구의 ‘같이 하는 기념기부’ 찾기</span>
                    </Button>
                  </ButtonContainer>
                </div>
              </>
            ) : (
              <></>
            )}
          </Container>
        </Section2>
        <Section3 className="by-sub-main-layout">
          <Container>
            <SectionHeader>
              <h2>
                <Tit size="s1" weight="black" className="nxnFont">
                  <span className="underline">셀럽 스토리</span>
                </Tit>
              </h2>
            </SectionHeader>

            <TogetherCard campaigns={storyItems} />
          </Container>
        </Section3>
        <Section3_1>
          <Container>
            <SectionHeader>
              <h2>
                <Tit size="s1" weight="black" className="nxnFont">
                  <span className="underline">후원 스토리</span>
                </Tit>
              </h2>
            </SectionHeader>

            <TogetherCard2 campaigns={supportItems} />
          </Container>
        </Section3_1>
        <Section4 className="by-sub-main-layout" ref={FindPage}>
          <Container>
            <TogetherTabSwiper
              type=""
              reqDetail={(aid: number, page: AnniProjectActionType) => {
                if (aid > 0) {
                  anniPrjtPopupOpen(page || AnniProjectActionType.detail, aid);
                }
              }}
            />
          </Container>
          <div className="source">
            <span className="source_pc">©UN0368721</span>
            <span className="source_m">©UN0226244</span>
          </div>
        </Section4>
        <Section5 className="by-sub-main-layout">
          <Container>
            <SectionHeader>
              <h2>
                <Tit size="s1">자주 묻는 질문</Tit>
              </h2>
            </SectionHeader>

            <AccordionComponent>
              {faqLists.map((faq) => (
                <AccordionItem
                  key={faq.id}
                  toggleKey={faq.id}
                  renderToggle={(onClick) => (
                    <NavigationButton
                      onClick={onClick}
                      className="accordion-opener"
                    >
                      {faq.title}
                    </NavigationButton>
                  )}
                >
                  <AccordionBody
                    dangerouslySetInnerHTML={{ __html: faq.contents }}
                  />
                </AccordionItem>
              ))}
            </AccordionComponent>
          </Container>
        </Section5>
        <SectionSpecialDay ref={Eng}>
          <Container>
            <SectionHeader className="with-desc">
              <h2>
                <Tit size="s2">Special Day Donation</Tit>
              </h2>
              <p className="header-dec">
                UNICEF’s ‘Special Day Donation’ refers to donating to celebrate
                birthdays, wedding anniversaries, graduations, and can also
                donate on behalf of your favorite idols! YOU can save children's
                lives by supporting UNICEF on your special days!
              </p>
            </SectionHeader>
            <article>
              <ul className="blit-list">
                <li>There is no need for separate membership registration.</li>
                <li>
                  If you want to donate online, please select the day you want
                  to celebrate and fill in the blanks. (Applicable only to
                  donors residing in Korea)
                </li>
                <li>
                  People living abroad may wire-transfer to the bank account
                  below. (There is no need to exchange currency to KRW)
                </li>
              </ul>
            </article>
            <article>
              <strong className="tit">
                [Korean Committee for UNICEF’s bank account information]{` `}
              </strong>
              <ul className="blit-list">
                <li>Bank Name: SHINHAN BANK</li>
                <li>Branch Name: Shinhan PWM Privilege Seoul Center</li>
                <li>
                  Branch Address: 39, Sejong-daero, Jung-gu, Seoul 100-743,
                  Korea
                </li>
                <li>Swift-Code: SHBKKRSE</li>
                <li>Account No: 100-019-976130 (KRW)</li>
                <li>Account Holder: UNICEF KOREA</li>
                <li>
                  Account Holder's address: 60 Seogang-ro, Mapo-gu, Seoul 04099,
                  Korea
                </li>
              </ul>
              <p className="dec">
                For further questions, please contact +82+2-721-5154, or email
                us at major@unicef.or.kr
              </p>
            </article>
          </Container>
        </SectionSpecialDay>
        {/* 기념기부 프로젝트 팝업 */}
        <AnniProjectPopup
          action={anniPrjtPopupAction}
          id={anniPrjtPopupId}
          isOpen={anniPrjtPopupState}
          queryParams=""
          goto={(argAction, argId) => {
            anniPrjtPopupOpen(argAction, argId);
          }}
          onRequestClose={anniPrjtPopupClose}
        />
      </Page>
    );
  },
);

export default TogetherTab;
